import Vue from "vue"
import config from '../../config'

export default {
    storeOrders(body, params = {}) {
        return Vue.http.post(config.apiBaseUrl + '/bling/request', body, { params }).then((response) => response.json());
    },
}